import styled from "styled-components";
import { TextPrimary, TextMessage } from "../../components";
import Styleguide, { Colors } from "../../theme";

export const ContainerOneProvider = styled.div`
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  justify-content: center;
  margin-bottom: 4rem;

  @media screen and (min-width: 640px) {
    flex-grow: 0;
  }
`;

export const ContainerListProvider = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  justify-content: center;
  margin: 0 auto;
  padding: 0px 24px;
  box-sizing: border-box;

  @media screen and (min-width: ${Styleguide.breakpoints.desktop}) {
    width: 496px;
    padding: 0;
    gap: 24px;
  }
`;

export const OneProviderImage = styled.img`
  display: block;
  margin: auto auto;
  max-width: 145px;

  @media screen and (min-width: 961px) {
    max-width: 152px;
  }

  @media screen and (min-width: 1367px) {
    max-width: 202px;
  }
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: 2fr 2fr;
  gap: 16px;
  justify-content: center;

  &:focus {
    outline: 2px solid ${Colors.lightBlue[100]};
    border-radiux: 8px;
  }
`;

export const LoadMoreButton = styled.button`
  width: 100%;
  height: 40px;
  font-family: GlobotipoTexto;
  font-weight: bold;
  font-size: 16px;
  color: ${Colors.gray[100]};
  background: ${Colors.gray[500]};
  border: 1px solid ${Colors.gray[100]};
  border-radius: 8px;
  cursor: pointer;

  &:hover {
    background: ${Colors.white};
    color: ${Colors.black};
    border: 1px solid ${Colors.black};
  }

  &:focus-visible {
    outline: 2px solid ${Colors.lightBlue[100]};
    outline-offset: 3px;
  }

  @media screen and (min-width: ${Styleguide.breakpoints.desktop}) {
    font-size: 18px;
    height: 48px;
  }
`;

export const ProviderNotFoundContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  h3 {
    font-family: GlobotipoTexto;
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 20px;
    color: #333333;
    margin: 16px 0px 8px 0px;
  }

  p {
    font-family: opensans-regular;
    font-size: 12px;
    color: #666666;
    margin: 0px 0px 24px 0px;
  }

  .buttonContainer {
    width: 100%;

    @media screen and (min-width: 650px) {
      width: 310px;
    }
  }
`;

export const Title = styled(TextPrimary)`
  text-align: left;
  margin: 0px;
  outline-color: #0669de;
`;

export const Description = styled(TextMessage)`
  text-align: left;
  outline-color: #0669de;
  max-width: 100%;
`;
